<template>
  <div class="person-info">
    <div class="template-title">参赛人员资料</div>
    <div class="player-content">
      <PlayerDownLoad :subjectTitle='courseTitle' :address='finalAddr + groupAddr' />
      <time-out :count='prepareTimes'/>
    </div>
    <div class="template-title margin-bt">比赛抽取演讲节段</div>
    <div v-for="(course, index) in courseware" :key="index">
      <upload-view
        :type='course.type'
        :fileDesc="''"
        :tag="''"
        :deleteable="false"
        :img='""'
        :icon='""'
        :activeIcon='course.icon'
        :index='index'
        :path='""'
        :name='course.title'
        :activityId="''"
        :playerId="''"
        :couldDownload="true"
        :couldPreview='true'
        :changeObj="{show: '', text: ''}"
        @download='() => downloadAttachment(course)'
        @preview='() => previewAttachment(course)'
      >
      </upload-view>
    </div>
  </div>
</template>
<script>
import { getCourseWareDetails } from '../service/contestantInfo'
import { Loading } from 'element-ui'
import download from '../assets/downloader'
import PlayerDownLoad from '@/components/player-download/index'
import TimeOut from '@/components/time-out/index'
import UploadView from '@/components/upload-view'
export default {
  data () {
    return {
      isQuit: true,
      activity_id: '',
      player_id: '',
      courseTitle: '',
      courseware: [],
      activityInfo: {},
      userInfo: {},
      finalAddr: '',
      groupAddr: '',
      pptIcon: require('@/assets/images/ppt-active.png'),
      pdfIcon: require('@/assets/images/pdf-active.png'),
      prepareTimes: 0
    }
  },
  components: {
    PlayerDownLoad,
    TimeOut,
    UploadView
  },
  methods: {
    downloadAttachment (obj) {
      console.log(obj)
      let url = this.encodeFileNameInUrl(obj)
      download(1, url, '')
    },
    encodeFileNameInUrl (obj) {
      return obj.url.indexOf('http') > -1 ? obj.url : obj.host + obj.url
      // if (!obj.title || obj.url.indexOf(obj.title) === -1) {
      //   return obj.url
      // }
      // let encodeFileName = encodeURIComponent(obj.title)
      // return obj.url.replace(obj.title, encodeFileName)
    },
    previewAttachment (obj) {
      let url = this.encodeFileNameInUrl(obj)
      if (obj.title.indexOf('pdf') !== -1) {
        window.open(url)
      } else {
        url = encodeURIComponent(this.encodeFileNameInUrl(obj))
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + url)
      }
    },
    fileTypes (filePath) {
      if (!filePath) {
        return {}
      }
      if (filePath.indexOf('.ppt') > -1) {
        return {
          type: 'ppt',
          icon: this.pptIcon
        }
      } else if (filePath.indexOf('.pdf') > -1) {
        return {
          type: 'pdf',
          icon: this.pdfIcon
        }
      } else {
        return {}
      }
    },
    getPrepareTimes (startDate) {
      if (!startDate) {
        this.prepareTimes = 0
        return
      }
      const startTimes = new Date(startDate.replace(/-/g, '/')).getTime() / 1000
      const currentTimes = new Date().getTime() / 1000
      if (startTimes <= currentTimes) {
        this.prepareTimes = 0
        return
      }
      this.prepareTimes = Math.floor(startTimes - currentTimes)
    }
  },
  mounted () {
    this.activityInfo = JSON.parse(localStorage.getItem('PersonInfo')).activity
    this.userInfo = JSON.parse(localStorage.getItem('PersonInfo')).user
    let modules = this.activityInfo.modules
    for (let i in modules) {
      if (modules[i].category === 'scene' && modules[i].module === 'scene_contest') {
        this.finalAddr = modules[i].properties.final_addr
      }
    }
    this.groupAddr = this.userInfo.group.site_addr
    getCourseWareDetails(this.activity_id, this.player_id)
      .then(res => {
        if (res.status === 'success') {
          this.getPrepareTimes(res.data.start_time)
          this.courseTitle = res.data.title
          this.courseware = res.data.resources.map(recource => {
            return {
              type: recource.type,
              icon: this.fileTypes(recource.title).icon,
              title: recource.title,
              url: recource.url,
              host: recource.host
            }
          })
          Loading.service().close()
        } else {
          Loading.service().close()
          this.courseTitle = res.msg ? res.msg : '出错了，请刷新'
        }
      }).catch(function (e) {
        console.log(e)
        Loading.service().close()
        this.courseTitle = '出错了，请刷新'
      })
  },
  created () {
    Loading.service()
    this.activity_id = this.$route.params.activityId
    this.player_id = this.$route.params.playerId
  },
  beforeDestroy () {
    clearInterval(this.timmer)
  }
}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.download-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  margin-top: 10px;
  justify-content: center;
  .courseware-download,
  .competition-info {
    flex: 1;
    height: 350px;
    border: 1px solid #efefef;
    background-color: #f9f9f9;
    box-sizing: border-box;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 20px;
    margin-top: 10px;
  }
}
.courseware-download {
  margin-right: 20px;
}
.title {
  font-size: 20px;
  line-height: 28px;
  &::before {
    content: "";
    margin-right: 6px;
    padding: 3px 4px;
    background-color: #c12b20;
  }
}
.download-list {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  .courseware {
    text-align: center;
    margin-right: 80px;
  }
  .courseware:last-child {
    margin-right: 0;
  }
}
.courseware-icon {
  margin-bottom: 10px;
  img {
    width: 78px;
    height: 88px;
    vertical-align: bottom;
  }
}
.btn-group {
  margin-top: 10px;
  font-size: 0;
  /deep/ .el-button {
    padding: 4px 14px;
    font-size: 16px;
    color: #393a51;
  }
}
.info-wrapper {
  display: flex;
  align-items: center;
  .counting-down {
    width: 210px;
    height: 210px;
    margin-right: 60px;
  }
  .position {
    font-size: 16px;
  }
}
.position-title {
  color: #666666;
}
.box-card {
  width: 50%;
  margin: 0 auto;
  padding-bottom: 50px;
}
.div_info {
  text-align: center;
  width: 100%;
  margin: 0 auto;
  height: 50%;
  padding-top: 4%;
}
.course {
  font-size: 31px;
  font-weight: 500;
}
.course_name {
  font-size: 22px;
  color: #333333;
  float: left;
}
a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 15px;
  box-sizing: border-box;
  background: rgba(249, 249, 249, 1);
  border-radius: 2px;
  border: 1px solid rgba(227, 227, 227, 1);
  display: inline-block;
  width: 485px;
  line-height: 50px;
  height: 50px;
  font-size: 22px;
  color: #4a90e2;
}
a:hover {
  color: blue;
}
.link_name {
  font-size: 22px;
  float: left;
}
.link-cai {
  /* margin-bottom: 13px; */
  overflow: hidden;
  display: flex;
  margin-top: 30px;
  align-items: center;
}
.link {
  float: left;
  margin-left: 30px;
}
.courseware-title {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 22px;
  margin: 0 auto;
}
.competiton-position {
  span {
    color: #1296db;
    margin-right: 10px;
  }
}
.logout {
  text-align: right;
  margin-top: 10px;
}

.person-info {
  width: 100%;
  max-width: 686px;
  margin: 0 auto;
  padding-top: 25px;
}

.template-title {
  font-size: 20px;
  font-weight: 600;
  color: #4E5A73;
  padding-left: 10px;
  position: relative;
  &::before {
    content: '';
    width: 6px;
    height: 20px;
    background: #F04037;
    position: absolute;
    left: 0;
    top: 5px;
  }
}

.person-info {
  width: 100%;
  max-width: 686px;
  margin: 0 auto;
  padding-top: 25px;
}

.player-wrapper {
  margin: 26px 0;
}

.player-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 26px 0;
}

.margin-bt {
  margin-bottom: 26px;
}
</style>



// WEBPACK FOOTER //
// src/views/CourseWareDetail.vue